import { render } from "./Dashboardapps.vue?vue&type=template&id=01d7f45a"
import script from "./Dashboardapps.vue?vue&type=script&lang=js"
export * from "./Dashboardapps.vue?vue&type=script&lang=js"

import "./Dashboardapps.vue?vue&type=style&index=0&id=01d7f45a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__